export const unwrapResource = (response) => response.data?.data ?? response.data

export const numericId = (value) => Number(value)

const messageTimestamp = (message) => Date.parse(message?.created_at ?? '')

export const sortMessages = (messages) => messages.sort((firstMessage, secondMessage) => {
  const firstTimestamp = messageTimestamp(firstMessage)
  const secondTimestamp = messageTimestamp(secondMessage)

  if (Number.isFinite(firstTimestamp) && Number.isFinite(secondTimestamp) && firstTimestamp !== secondTimestamp) {
    return firstTimestamp - secondTimestamp
  }

  const firstId = numericId(firstMessage.id)
  const secondId = numericId(secondMessage.id)

  if (Number.isFinite(firstId) && Number.isFinite(secondId)) {
    return firstId - secondId
  }

  return String(firstMessage.id).localeCompare(String(secondMessage.id))
})
